import { render } from "./InvoicesAll.vue?vue&type=template&id=32ac4b6d&scoped=true&ts=true"
import script from "./InvoicesAll.vue?vue&type=script&lang=ts"
export * from "./InvoicesAll.vue?vue&type=script&lang=ts"

import "./InvoicesAll.vue?vue&type=style&index=0&id=32ac4b6d&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ac4b6d"]])

export default __exports__